import type { PropertySort } from '../../types/property'

export const AMENITY_FILTERS = ['wifi', 'parking', 'pool', 'kitchen', 'terrace'] as const
export const ACCESSIBILITY_FILTERS = ['pmr', 'elevator', 'accessible_shower'] as const
export const SORTS: PropertySort[] = [
  'recommended',
  'price_asc',
  'capacity_desc',
  'available_soon',
  'name_asc',
  'newest',
]

export type SearchKey =
  | 'q'
  | 'city'
  | 'country'
  | 'type'
  | 'available_from'
  | 'available_to'
  | 'flex'
  | 'guests'
  | 'min_bedrooms'
  | 'min_bathrooms'
  | 'min_price'
  | 'max_price'
  | 'amenities'
  | 'accessibility'
  | 'cancellation'
  | 'has_availability'
  | 'only_active'
  | 'sort'
  | 'page'

export type UpdateSearch = (next: Partial<Record<SearchKey, string | null>>) => void

export type PropertyFiltersValues = {
  country: string
  type: string
  minBedrooms: string
  minBathrooms: string
  minPrice: string
  maxPrice: string
  amenities: string[]
  accessibility: string[]
  cancellation: string
  hasAvailability: boolean
  /** True when available_from + available_to are set (required for the availability filter). */
  hasDateRange: boolean
  onlyActive: boolean
}
